import { createFileRoute } from '@tanstack/react-router'
import { LoginMsal } from './-src/components/login-msal'

export const Route = createFileRoute('/login/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <LoginMsal />
}
